<template>
  <div style="padding: 15px;">
    <el-row>
      <el-form ref="form" :rules="rules" :model="form" label-width="160px">
        <el-col :span="24">
          <el-form-item label="实际承运人应收现金">
            <el-input v-model="form.deliveryCashFee" :disabled="true" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="已打款金额">
            <el-input v-model="form.allotAmount" :disabled="true" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="已分配油点">
            <el-input v-model="form.allotOil" :disabled="true" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="凭证支付">
            <el-input v-model="form.freight" :disabled="true" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-button
            type="primary"
            :disabled="updating"
            @click="funcSubmit('form')"
            >确定</el-button
          >
        </el-col>
      </el-form>
    </el-row>
    <el-row style="margin-top:20px;">
      <el-col :span="24">
        <vxe-table border height="250" :data="tableData">
          <vxe-table-column field="orderDetailNumber" title="运单号" />
          <vxe-table-column field="amount" title="分配现金" />
          <vxe-table-column field="gmtCreated" title="分配时间" />
        </vxe-table>
        <vxe-pager
          :loading="loading"
          :page-sizes="Pagingconf"
          :current-page.sync="formPage.pageNum"
          :page-size.sync="formPage.pageSize"
          :total="formPage.total"
          :layouts="[
            'PrevJump',
            'PrevPage',
            'Number',
            'NextPage',
            'NextJump',
            'Sizes',
            'FullJump',
            'Total'
          ]"
          @page-change="handlePageChange"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { remitDefinite } from "@/api/transport";
import request from "@/utils/request";
export default {
  name: "CreditPay",
  data() {
    return {
      show: true,
      count: "",
      loading: false,
      updating: false,
      tableData: [],
      form: {
        orderDetailCodes: [],
        freight: "",
        deliveryCashFee: "",
        totalAmount: "",
        allotOil: ""
      },
      formPage: {
        payTypes: "3,4,5",
        orderDetailCode: "",
        pageNum: 1,
        pageSize: 20,
        totaltotal: 0
      },
      Pagingconf: [],
      rules: {}
    };
  },
  methods: {
    getInfo(row) {
      this.form = row;
      this.formPage.orderDetailCode = row.orderDetailCodes;
      // console.log(this.formPage)
      this.Allocationrecord();
    },
    close() {
      this.count = 0;
      this.updating = false;
    },
    // 提交
    funcSubmit(form) {
      this.updating = true;
      if (this.form.orderDetailCodes.length > 0) {
        let orderDetailCodes = this.form.orderDetailCodes;
        const rLoading = this.openLoading();
        return request({
          url: "/ntocc-tms-api/maYiCreditFlow/proof/apply",
          method: "get",
          params: { orderDetailCodes: orderDetailCodes }
        })
          .then(response => {
            this.$message({ message: response.msg, type: "success" });
            this.count = 1;
            this.$emit("hideModel", response.data);
          })
          .finally(res => {
            rLoading.close();
            this.updating = false;
          });
      }
    },
    // 记录列表
    Allocationrecord() {
      this.tableData = [];
      this.loading = true;

      remitDefinite(this.formPage).then(response => {
        this.tableData = response.data.records;
        response.data.total > 10000
          ? (this.Pagingconf = [20, 30, 50, 100, 10000])
          : (this.Pagingconf = [20, 30, 50, 100, response.data.total || 1]);
        this.formPage.total = response.data.total;
        this.loading = false;
      });
    },
    // 分页
    handlePageChange({ currentPage, pageSize }) {
      this.formPage.pageNum = currentPage;
      this.formPage.pageSize = pageSize;
      this.Allocationrecord();
    },
    isFloor(e) {
      e.target.value = e.target.value.match(/^\d*(\.?\d{0,1})/g)[0] || null;
    }
  }
};
</script>
